/** @format */

import React from "react";
import { SearchIcon } from "@heroicons/react/outline";
import { Transition } from "@headlessui/react";
import { uid } from "uid";
import Navbar from "../components/navbar/Navbar";
import { AppDataContext } from "../stateManagement/context/AppDataContext";
import {
  getStudiosList,
  GetTrendingAnimeList,
  searchAnime,
} from "../services/AnimeService";
import {
  SET_SEARCH_RESULT,
  SET_SEARCH_STATUS,
  SET_STUDIO_LIST,
} from "../stateManagement/variables";
import { toast } from "react-toastify";
import LoadingText from "./LoadingScreens/LoadingText";
import ContentCardNoHover from "./contentCards/ContentCardNoHover";
import { Link } from "react-router-dom";
import { filterByStudio } from "./helpers/arrayHelpers";
import Footer from "../components/footer/Footer";
import GoogleAd from "../ad/GoogleAd";
import { Helmet } from "react-helmet";

export default function Search() {
  //scrolling to top at page load
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white relative dark:bg-dark-800">
      <Helmet title="Search" />
      <Navbar />
      <br />
      <div className="  z-[60] mt-12 min-h-screen  rounded-2xl bg-white dark:bg-dark-800  mb-96   w-full">
        <div className="relative min-h-screen w-full">
          <RenderBar />
        </div>
      </div>
      <Footer />
    </div>
  );
}

function RenderBar() {
  const { appData, dispatch } = React.useContext(AppDataContext);
  const [isWindowOpen, setWindowOpen] = React.useState("search");

  const handelClick = async () => {
    let val = document.getElementById("search-input").value;
    if (!val) return toast.error("Please enter a value to search");
    dispatch({ type: SET_SEARCH_STATUS, payload: "loading" });
    document.getElementById("head").innerHTML = "Results for " + val;
    const res = await searchAnime(val);
    if (!res.data.length) {
      dispatch({ type: SET_SEARCH_STATUS, payload: "notfound" });
      return toast("No results found");
    }

    dispatch({ type: SET_SEARCH_RESULT, payload: res.data });
    dispatch({ type: SET_SEARCH_STATUS, payload: "resolved" });
    console.log(appData.search);
  };

  const handelEnter = (e) => {
    if (e.key === "Enter") handelClick();
  };

  return (
    <div className="bg-white  sticky top-0 dark:bg-dark-800  w-full md:container  m-auto ">
      <div
        onClick={() => setWindowOpen("search")}
        className="flex  m-auto gap-3 items-center relative  justify-center p-1 rounded-md"
      >
        <input
          onKeyDown={(e) => handelEnter(e)}
          id="search-input"
          className="  w-full border-2 dark:border-dark-100 border-gray-300 dark:bg-dark dark:bg-dark-100 dark:text-white  bg-white h-10 mt-2  px-5  pl-8  rounded-full text-sm focus:outline-none"
          type="search"
          name="search"
          placeholder="Search"
        />
        <button
          onClick={handelClick}
          className="btn  bg-red-500 dark:text-white"
        >
          Search
        </button>
        <SearchIcon className="block  text-yellow-400  h-5  w-5 mt-2 absolute left-3" />
      </div>
      <RenderTest isWindowOpen={isWindowOpen} setWindowOpen={setWindowOpen} />
    </div>
  );
}

function RenderTest(props) {
  const { isWindowOpen, setWindowOpen } = props;

  return (
    <>
      <div className="container h-full  m-auto px-3  cursor-pointer  relative    w-full ">
        <div
          onClick={() => setWindowOpen("categories")}
          className="w-36 dark:text-white  flex flex-row flex-wrap p-2"
        >
          Categories
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5  m-1 text-yellow-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>{" "}
        </div>
        <div
          onClick={() => setWindowOpen("filters")}
          className=" md:w-24 dark:text-white  cursor-pointer   flex absolute top-3 right-5 flex-row flex-wrap  place-self-end"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 m-1 text-yellow-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            />
          </svg>
          Filter
        </div>
      </div>

      <Transition
        show={isWindowOpen === "filters"}
        as={React.Fragment}
        enterFrom="transform -translate-x-full duration-300"
        enterTo="transform  translate-x-0 duration-300 "
        leave="transition ease-in duration-300"
        leaveFrom="transform translate-x-0 "
        leaveTo="transform translate-x-full duration-300 "
      >
        <div className="overflow-scroll h-screen custom-scroll">
          <RenderFilters />
        </div>
      </Transition>

      <Transition
        show={isWindowOpen === "categories"}
        as={React.Fragment}
        enterFrom="transform scale-0 duration-300"
        enterTo="transform scale-100 duration-300 "
        leave="transition ease-in duration-300"
        leaveFrom="transform scale-100"
        leaveTo="transform scale-0 duration-300"
      >
        <div>
          <RenderStudios />
        </div>
      </Transition>

      <Transition
        show={isWindowOpen === "search"}
        as={React.Fragment}
        enterFrom="transform -translate-x-full duration-300"
        enterTo="transform  translate-x-0 duration-300 "
        leave="transition ease-in duration-300"
        leaveFrom="transform translate-x-0 "
        leaveTo="transform translate-x-full duration-300 "
      >
        <div>
          <header className=" dark:bg-dark-500  bg-white shadow">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <h1
                id="head"
                className="text-3xl font-bold dark:text-white text-gray-900"
              >
                Results
              </h1>
            </div>
          </header>
          <main>
            <RenderSearchResults />
          </main>
        </div>
      </Transition>
    </>
  );
}

function RenderFilters() {
  let array = new Array(22).fill("Year");
  for (let i = 0; i < array.length; i++) {
    array[i] = `Year ${2000 + i}`;
  }

  return (
    <>
      <div className="h-full overflow-scroll custom-scroll dark:bg-dark-100 mt-5 p-2 flex flex-wrap flex-row gap-7  w-full">
        {/* <div className="flex h-36 flex-wrap flex-col  w-72 rounded-lg dark:bg-gray-800 p-5 bg-gray-50">
          <p className="text-2xl dark:text-white">Anime Type </p>
          <div className="flex flex-wrap gap-5 flex-row">
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              All
            </div>
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              Movies
            </div>
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              TV series
            </div>
          </div>
        </div> */}

        {/* ROund 2 */}
        {/* <div className="flex flex-wrap h-36  flex-col w-72 rounded-lg dark:bg-gray-800 p-5 bg-gray-50">
          <p className="text-2xl dark:text-white">Audio </p>
          <div className="flex flex-wrap gap-5 flex-row">
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              All
            </div>
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              Sub
            </div>
            <div className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500">
              Dub
            </div>
          </div>
        </div> */}

        {/* ROund 3 */}
        <div className="flex flex-wrap h-60 flex-col w-72 rounded-lg dark:bg-gray-800 p-5 bg-gray-50">
          <p className="text-2xl dark:text-white">Status </p>
          <div className="flex flex-wrap gap-5 mt-5 flex-row">
            <Link
              to="/title/Finished"
              className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
            >
              Completed
            </Link>
            <Link
              to="/title/Ongoing"
              className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
            >
              Ongoing
            </Link>
            <Link
              to="/news/anime"
              className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
            >
              Anime News
            </Link>
          </div>
        </div>

        {/* ROund 4 */}
        {/* <div className="flex flex-wrap flex-col w-full rounded-lg dark:bg-gray-800 p-5 bg-gray-50">
          <p className="text-2xl dark:text-white">Released in </p>
          <div className="flex flex-wrap gap-5 pb-20 flex-row">
            {array.map((item) => (
              <div
                key={uid()}
                className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
              >
                {item}
              </div>
            ))}
          </div>
        </div> */}
        <GoogleAd slot="1615986039" />
      </div>
    </>
  );
}

// function RenderFiltersChild() {
//   return <div></div>;
// }

function RenderStudios() {
  const { appData, dispatch } = React.useContext(AppDataContext);
  const [anime, setAnime] = React.useState([]);
  const { studioList } = appData;
  const [filteredAnimeList, setFilteredAnimeList] = React.useState([]);
  React.useEffect(() => {
    const resolver = async () => {
      let res = await getStudiosList();
      let anime = await GetTrendingAnimeList();
      setAnime(anime.data);
      dispatch({ type: SET_STUDIO_LIST, payload: res.data });
    };
    resolver();
    // eslint-disable-next-line
  }, []);
  const handelClick = (studio) => {
    setFilteredAnimeList(filterByStudio(anime, studio));
  };

  return (
    <div className="flex flex-wrap flex-col w-full rounded-lg dark:bg-gray-800 p-5 bg-gray-50">
      <p className="text-2xl font-montserrat dark:text-white">By Studios </p>
      <div className="flex px-3 gap-y-5   md:px-5 mt-5 h-auto flex-row justify-evenly md:justify-between flex-wrap w-full gap-2 sm:gap-3 ">
        {filteredAnimeList.map((anime) => (
          <ContentCardNoHover
            data={anime}
            key={uid()}
            className="shadow-md hover:shadow-lg duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
          />
        ))}
      </div>
      <div className="flex flex-wrap mt-3 max-h-screen overflow-scroll custom-scroll   gap-5 pb-56 md:pb-20 flex-row">
        {!studioList.length ? (
          <p className="text-center dark:text-white font-montserrat text-lg">
            Loading...
          </p>
        ) : (
          studioList.map((item) => (
            <div
              key={item.id}
              onClick={() => handelClick(item.name)}
              className="cursor-pointer shadow-md hover:shadow-lg bg-white duration-200 p-3 rounded-2xl dark:text-white dark:bg-dark-500"
            >
              {item.name}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function RenderSearchResults() {
  const { appData } = React.useContext(AppDataContext);
  const { search } = appData;
  return (
    <div className="flex px-3 gap-y-5 mb-96  md:px-5 mt-5 h-auto flex-row justify-evenly md:justify-between flex-wrap w-full gap-2 sm:gap-3 ">
      <GoogleAd slot="5363659350" />

      {search.status === "ideal" ? (
        <RenderSearchPlaceholder
          title={"UwU"}
          message={" Try searching for the anime you are Looking for."}
        />
      ) : search.status === "loading" ? (
        <RenderLoading />
      ) : search.status === "notfound" ? (
        <RenderSearchPlaceholder
          title={"OOps!"}
          message={
            "We cant find anything related to your search query. Let us know what you are looking for ,We'll do our best to add it to our database  "
          }
        />
      ) : (
        search.results.map((data) => (
          <ContentCardNoHover key={uid()} data={data} />
        ))
      )}
    </div>
  );
}

function RenderSearchPlaceholder(props) {
  return (
    <div className="dark:text-white w-full p-3">
      <p className="text-center font-montserrat text-3xl font-semibold">
        {" "}
        {props.title}
      </p>
      <br />
      <p className="text-center font-montserrat text-xl font-semibold">
        {props.message}
      </p>
    </div>
  );
}

function RenderLoading() {
  return (
    <div className="flex px-3 gap-y-5   md:px-5 mt-5 h-auto flex-row justify-evenly md:justify-between flex-wrap w-full gap-2 sm:gap-3  ">
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
    </div>
  );
}